import { OperatingSystemService } from '../operating-system-service';
import { hasModifier } from './has-modifier';

export const baseKey = {
  key: undefined,
  hasCtrlEquivalent: false,
  hasShift: false,
  hasModifier: false,
  hasAlt: false,
};

export const convertKeyToDefaultKeyObject = (key) => {
  if (typeof key === 'object') {
    return { ...baseKey, ...key };
  }

  const shiftWhitelist = '!@#$%^&*()_+{}:":<>?|~'.split('');
  let isShiftAllowed = false;
  let isModifierAllowed = false;

  if (shiftWhitelist.includes(key)) {
    isShiftAllowed = true;
    isModifierAllowed = true;
  }

  let transformedKey = key;
  if (transformedKey === '*') {
    transformedKey = '**';
  }

  return {
    ...baseKey,
    key: typeof transformedKey === 'string' ? transformedKey.toLowerCase() : transformedKey,
    hasShift: isShiftAllowed,
    hasModifier: isModifierAllowed,
  };
};

export const convertEventToKeyObject = (event) => {
  return {
    key: event.key.toLowerCase(),
    hasCtrlEquivalent: OperatingSystemService.isMac() ? event.metaKey : event.ctrlKey,
    hasShift: event.shiftKey,
    hasModifier: hasModifier(event),
    hasAlt: event.altKey,
    eventReference: event,
    originalKey: event.key,
  };
};
